<template>
  <transition name="fade" appear>
    <div class="event-deets drop-shadow">
      <h3>Event Details</h3>
      <table class="detail-list">
        <tr>
          <th>Created On</th>
          <td>{{ $store.getters.getEventDetails.created }}</td>
        </tr>
        <tr>
          <th>Author</th>
          <td>{{ $store.getters.getEventDetails.author }}</td>
        </tr>
        <tr>
          <th>Participants</th>
          <td>{{ $store.getters.getEventDetails.participants }}</td>
        </tr>
      </table>
    </div>
  </transition>
</template>

<style scoped>
.event-deets {
  padding: 1.5rem;
  width: 100%;
  border-radius: 12px;
  background-color: #ffffff;
  border: 1px solid #f5f5f5;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.event-deets h3 {
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 1rem;
  color: #1a1a1a;
  margin-top: 0;
  margin-left: 0;
}

.detail-list {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.detail-list tr {
  color: #525252;
  font-size: 0.875rem;
}

.detail-list th {
  font-weight: 400;
  text-transform: uppercase;
  text-align: left;
  color: #737373;
  font-size: 0.75rem;
  letter-spacing: 0.02em;
  padding-bottom: 0.25rem;
}

.detail-list td {
  text-align: right;
  color: #404040;
  font-weight: 400;
  padding-bottom: 0.25rem;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

@media (max-width: 768px) {
  .event-deets {
    padding: 1.25rem;
  }

  .event-deets h3 {
    font-size: 1rem;
  }

  .detail-list tr {
    font-size: 0.8rem;
  }

  .detail-list th {
    font-size: 0.7rem;
  }
}
</style>
